/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { UpdateUserSettingsRequest } from '../models/UpdateUserSettingsRequest';
import type { UserSettings } from '../models/UserSettings';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class UserSettingsService {
    /**
     * Find user settings
     * Finds the settings of the executing user.
     *
     * @returns UserSettings The user's settings
     * @throws ApiError
     */
    public static findSettings(): CancelablePromise<UserSettings> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/user/settings',
        });
    }
    /**
     * @deprecated
     * Deprecated - Update user settings
     * Use [updateSettings](#/User%20Settings/updateSettings) (`PATCH`) instead.
     *
     * @returns UserSettings The updated user's settings
     * @throws ApiError
     */
    public static updateSettingsDeprecated({
        requestBody,
    }: {
        /**
         * The settings to be updated
         */
        requestBody: UpdateUserSettingsRequest,
    }): CancelablePromise<UserSettings> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/user/settings',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Update user settings
     * Updates the settings of the executing user. Only provided (if valid)
     * fields will be updated.
     *
     * @returns UserSettings The updated user's settings
     * @throws ApiError
     */
    public static updateUserSettings({
        requestBody,
    }: {
        /**
         * The settings to be updated
         */
        requestBody: UpdateUserSettingsRequest,
    }): CancelablePromise<UserSettings> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/dashboard/api/v1/user/settings',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
